<template>
  <div class="columns login-block">
    <div class="column is-3" />
    <div class="column is-6">
      <h2 class="subtitle is-2 has-text-centered">
        Forgot your password?
      </h2>
      <div class="box">
        <div class="is-clearfix">
          <router-link to="/">
            <button
              class="delete is-pulled-right mb-2"
              aria-label="close"
            />
          </router-link>
        </div>
        <form>
          <div class="field">
            <label class="label">Please enter your email address to retrieve your password</label>
            <p class="control has-icon has-icon-right">
              <input
                v-model="email"
                class="input"
                type="email"
                placeholder="jsmith@example.com"
              >
              <span class="icon">
                <i class="far fa-user" />
              </span>
            </p>
          </div>
          <div class="field">
            <div class="control">
              <button
                class="button is-info"
                type="button"
                @click="send()"
              >
                Send
              </button>
            </div>
          </div>
        </form>
      </div>
    </div>
    <div class="column is-3" />
  </div>
</template>

<script>
  import axios from 'axios'
  export default {
    name: 'RestorePassword',
    data () {
      return {
        email: ''
      }
    },
    methods: {
      send () {
        this.$axios({
          method: 'POST',
          url: 'general/forgotpwd',
          headers: {
            Authorization: '84cd7a9a97d4c1d8f6402f9389711560',
            'Accept': 'application/json',
            'Content-Type': 'application/json'
          },
          data: {
            email: this.email
          }
        })
          .then((res) => {
            this.$emit('message',
              {
                showDialog: true,
                error: false,
                message: `Your login information has been sent to the email address on file, please check it for further instructions.`
              })
            this.$router.push({path: '/'})
          })
          .catch((err) => {
            console.log(err)
            this.$emit('message',
              {
                showDialog: true,
                error: true,
                message: err.response.data.message
              })
          })
      }
    }
  }
</script>
